import React from "react";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import { usePortalHostBody } from "~/context/PortalHostContext";

// Button whose tooltip opens in the document the modal actually lives in — inside a
// popout window the module-level `document` is still the main window's (issue #375).
// Must be rendered inside a ModalBase (it supplies the host body via context).
const HostTooltipButton = ({
  tooltipOptions,
  "data-evo-id": evoId,
  ...props
}) => {
  const appendTo = usePortalHostBody();
  // evoId is forwarded explicitly: evo-id/require-evo-id injects a literal
  // data-evo-id="TODO" when it doesn't see the attribute, and that literal would
  // win over the caller's id coming through the spread.
  return (
    <Button
      {...props}
      tooltipOptions={{ ...tooltipOptions, appendTo }}
      data-evo-id={evoId}
    />
  );
};

HostTooltipButton.propTypes = {
  tooltipOptions: PropTypes.object,
  "data-evo-id": PropTypes.string,
};

export default HostTooltipButton;
